import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./PaymentMethods.scss";

class MercadoPago extends Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps) {
    if (this.props.submit !== prevProps.submit && this.props.submit) {
      const payButton = document.getElementById("pay-btn");
      if (payButton) {
        (function () {
          function $MPC_load() {
            window.$MPC_loaded !== true &&
              (function () {
                var s = document.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = document.location.protocol + "//resources.mlstatic.com/mptools/render.js";
                var x = document.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);
                window.$MPC_loaded = true;
              })();
          }
          window.$MPC_loaded !== true
            ? window.attachEvent
              ? window.attachEvent("onload", $MPC_load)
              : window.addEventListener("load", $MPC_load, false)
            : null;
        })(); // eslint-disable-line
        payButton.click();
      }
    }
  }

  render() {
    const { initPoint } = this.props;
    return (
      <a
        id="pay-btn"
        className={styles.paymentButton}
        name="MP-Checkout"
        href={initPoint}
        mp-mode="redirect"></a>
    );
  }
}

MercadoPago.propTypes = {
  initPoint: PropTypes.string,
};

export default MercadoPago;
